import { render, staticRenderFns } from "./NewTaxModal.vue?vue&type=template&id=58706a9a&scoped=true"
import script from "./NewTaxModal.vue?vue&type=script&lang=js"
export * from "./NewTaxModal.vue?vue&type=script&lang=js"
import style0 from "./NewTaxModal.vue?vue&type=style&index=0&id=58706a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58706a9a",
  null
  
)

export default component.exports